import { useEffect } from "react";
import { Link, useNavigate } from "react-router";
import { Notification } from "@/components/admin/notification";
import { Button } from "@/components/ui/button";
import { useAuthProvider, useTranslate } from "ra-core";
import { useConfigurationContext } from "../root/ConfigurationContext";

export const ConfirmationRequired = () => {
  const translate = useTranslate();
  const { darkModeLogo: logo, title } = useConfigurationContext();
  const authProvider = useAuthProvider();
  const navigate = useNavigate();

  // The email link confirms the account in another tab. When the person
  // comes back here, open the CRM if that tab already signed them in.
  useEffect(() => {
    if (!authProvider) return;
    const check = () => {
      if (document.visibilityState !== "visible") return;
      authProvider
        .checkAuth({})
        .then(() => navigate("/"))
        .catch(() => {});
    };
    window.addEventListener("focus", check);
    document.addEventListener("visibilitychange", check);
    return () => {
      window.removeEventListener("focus", check);
      document.removeEventListener("visibilitychange", check);
    };
  }, [authProvider, navigate]);

  return (
    <div className="h-screen p-8">
      <div className="flex items-center gap-4">
        <img src={logo} alt={title} width={24} />
        <h1 className="text-xl font-semibold">{title}</h1>
      </div>
      <div className="h-full text-center">
        <div className="max-w-sm mx-auto h-full flex flex-col justify-center gap-4">
          <h1 className="text-2xl font-bold mb-4">
            {translate("crm.auth.welcome_title", {
              _: "Welcome to Atomic CRM",
            })}
          </h1>
          <p className="text-base mb-4">
            {translate("crm.auth.confirmation_required", {
              _: "Please follow the link we just sent you by email to confirm your account.",
            })}
          </p>
          <Button
            variant="outline"
            className="mx-auto"
            render={<Link to="/login" />}
          >
            {translate("crm.auth.confirmed_sign_in", {
              _: "I've confirmed, sign in",
            })}
          </Button>
        </div>
      </div>
      <Notification />
    </div>
  );
};

ConfirmationRequired.path = "/sign-up/confirm";
